import AppLoader from '@/components/AppLoader';
import { ReactNode } from 'react';
import { useInvitationTenantDomainRedirect } from './invitation-tenant-domain-redirect.controller';

/**
 * Invited users sign in on the domain of their own tenant, so an invitation link opened on any other
 * domain is sent there before rendering its children, which would ask for a sign-in on the wrong domain.
 */
export default function InvitationTenantDomainRedirect({ children }: { children: ReactNode }) {
	const { isLoading } = useInvitationTenantDomainRedirect();

	if (isLoading) {
		return <AppLoader />;
	}

	return <>{children}</>;
}
